import Vue from 'vue';
import $ from 'jquery';
import JSZip from 'jszip';
require('setimmediate');

import '@progress/kendo-ui';
import '../lib/doka/doka.min.css';

import '../scss/app.scss';

import {Button, FloatingActionButton} from '@progress/kendo-vue-buttons';
import {DateinputsInstaller} from '@progress/kendo-dateinputs-vue-wrapper';
import {DropdownsInstaller} from '@progress/kendo-dropdowns-vue-wrapper';
import {GridInstaller} from '@progress/kendo-grid-vue-wrapper';
import {InputsInstaller} from '@progress/kendo-inputs-vue-wrapper';
import {LayoutInstaller} from '@progress/kendo-layout-vue-wrapper';
import {Window} from '@progress/kendo-window-vue-wrapper';

require('./util');
import variables from '../webpack.var';
import Api from './api';
import Events from './events';
import Form from './form';
import Grid from './grid';
import Queue from './timedqueue/timedqueue';
import Socket from './socket';

import Announcements from '../components/announcements.vue';
import Audit from '../components/audit.vue';
import Demographics from '../components/demographics.vue';
import DrawPad from '../components/drawpad.vue';
import Login from '../components/login.vue';
import Narrative from '../components/narrative.vue';
import Reset from '../components/reset.vue';
import SearchBox from '../components/searchbox.vue';
import SigPad from '../components/sigpad.vue';
import SimpleDemos from '../components/simpledemos.vue';
import Style from '../components/style.js';
import TwoFA from '../components/twofa.vue';
import Welcome from '../components/welcome.vue';

Vue.use(DateinputsInstaller);
Vue.use(DropdownsInstaller);
Vue.use(GridInstaller);
Vue.use(InputsInstaller);
Vue.use(LayoutInstaller);

Array.prototype.peek = function () {
  return this.length ? this[this.length - 1] : undefined;
};

const REGEXPS = {
  IS_RESET: /^https:\/\/(test\.|)ccc-webservices.com\/reset\b/
};
const ROW_HEIGHT = 26;  // pixels
const SLYCE_URL = 'https://plugin.slycepay.com';
const CONSTANTS = {
  DATE_FORMATS: [
    'M/d/yyyy', 'M-d-yyyy', 'M/d/yy', 'M-d-yy', 'MMddyyyy', 'Mddyyyy', 'MMddyy',
    'Mddyy'
  ]
};

function noop () {}
function beforeunload(event) {
  // 1. setTimeout bumps the callback to the next event loop
  // 2. beforeunload execution continues
  // 3. preventDefault()/returnValue causes the browser to show a "really
  //    leave?" dialog and freeze the event loop
  // 4. when the user responds the event loop resumes, triggering the
  //    callback from setTimeout
  setTimeout(function (socket) {
    socket.disconnect(function () {socket.socket.connect()});
  }, 5, window.vm.$options.socket);
  event.preventDefault();
  return (event.returnValue = 'Please exit normally, if possible.');
}

window.$ = $;
window.JSZip = JSZip;
window.KENDO_DATA_KEYS = {
//role: 'kendo-data-key'
  button: 'kendo-button',
  floatingbutton: 'kendo-floating-action-button',
  calendar: 'kendo-calendar',
  combobox: 'kendo-combo-box',
  datepicker: 'kendo-date-picker',
  grid: 'kendo-grid',
  maskedtextbox: 'kendo-masked-text-box',
  tabstrip: 'kendo-tab-strip'
};

// make jQuery honor cached forms
$.ajaxPrefilter(function (options) {
  options.url =
    options.url.replace(/^\/static((?:\/[^/]+)+\/)\d{10}\.([^/]+)$/, '$1$2');
});

// alter grid keyboard navigation
(function (functions) {
  var handleEnd = functions._handleEnd;
  var handleHome = functions._handleHome;
  var handleEnterKey = functions._handleEnterKey;
  // swap ctrl+end with end, same with home
  functions._handleEnd = function (event, ctrl) {
    return handleEnd.call(this, event, !ctrl);
  };
  functions._handleHome = function (event, ctrl) {
    return handleHome.call(this, event, !ctrl);
  };
  // make enter select the current row/cell
  functions._handleEnterKey = function () {
    var props = window.vm.get_props(this.element.data('safe-id'));
    if (!props)
      return console.warn('No properties for navigatable grid');
    var checkboxes =
      props.columns && props.columns.length && props.columns[0].selectable;
    var focused = this.current();
    var selected = this.select();
    switch (checkboxes ? 'multirow' : props.selectable) {
    case 'multirow':
      focused = focused.closest('tr');
      // falls through
    case 'multicell':
      // if focused cell/row is already selected, deselect it; otherwise add
      // it to the current selection
      if (selected.is(focused))
        this.select(selected.not(focused));
      else
        this.select(selected.add(focused));
      break;
    case 'cell':
      this.select(focused);
      break;
    case 'row':
      this.select(focused.closest('tr'));
      break;
    default:
      return console.warn('Grid not selectable');
    }
    if (!props.single_click_select)
      Events.on_grid_select(this);
    return false;
  };
  // make space open the grid context menu
  functions._handleSpaceKey = function (selection, ctrl) {
    if (ctrl) {
      handleEnterKey.call(this, selection, this.table.get(0), this.table);
      return false;
    }
    // triggers select by default, which opens the grid context menu
  };
  // we don't like kendo's default behavior so do ours instead
  functions._scrollTo = function (target, container) {
    console.debug('grid-scrollTo', this, target, container);
    if (this.chi_mousedown_el || this.chi_dragged_click)
      return;
    var dimension = 'height';
    var side = 'top';
    var scroll = 'scrollTop';
    if (target.tagName === 'TD') {
      dimension = 'width';
      side = 'left';
      scroll = 'scrollLeft';
    }
    var $container = $(container);
    var $target = $(target);
    var cscroll = $container[scroll]();
    var cabspos = {min: 0, max: $container[dimension]()};
    var crelpos = {min: cabspos.min + cscroll, max: cabspos.max + cscroll};
    var toffset = $target.offset()[side] - $container.offset()[side] + cscroll;
    var tpos = {min: toffset, max: toffset + $target[dimension]()};
    var visible = (tpos.min >= crelpos.min && crelpos.max >= tpos.max);
    var min_edge_ok = tpos.min >= crelpos.min + ROW_HEIGHT;
    var usable = (min_edge_ok && crelpos.max >= tpos.max + ROW_HEIGHT);
    if (!visible)
      $container[scroll]((tpos.min + tpos.max - cabspos.max) / 2);
    else if (!usable)
      $container[scroll](cscroll + (ROW_HEIGHT * (min_edge_ok ? 1 : -1)));
  };
})(window.kendo.ui.Grid.fn);

// prevent escape from closing windows
(function (functions) {
  var keydown = functions._keydown;
  functions._keydown = function (event) {
    if (event.which !== 27)
      keydown.apply(this, arguments);
  };
})(window.kendo.ui.Window.fn);


window.os = (function (platform, user_agent) {
  if (platform.includes('Win'))
    return 'windows';
  else if (platform.includes('Mac'))
    return 'mac';
  else if (platform.includes('iPad') || platform.includes('iPhone'))
    return 'ios';
  else if (platform.includes('Linux') && user_agent.includes('CrOS'))
    return 'chrome';
  else
    return '';
})(window.navigator.platform, window.navigator.userAgent);
window.vm = new Vue({
  components: {
    'chi-announcements': Announcements,
    'chi-audit': Audit,
    'chi-demographics': Demographics,
    'chi-drawpad': DrawPad,
    'chi-narrative': Narrative,
    'chi-searchbox': SearchBox,
    'chi-sigpad': SigPad,
    'chi-simple-demos': SimpleDemos,
    'chi-style': Style,
    'chi-welcome': Welcome,
    'kendo-button': Button,
    'kendo-floating-action-button': FloatingActionButton,
    Login: Login,
    Reset: Reset,
    TwoFA: TwoFA,
    Window: Window
  },
  computed: {
    context_menu_target: function () {
      var win = this.windows.peek();
      var target = win ? '#' + win.id : 'html';
      return target;
    }
  },
  data: {
    auth_component:
      REGEXPS.IS_RESET.test(window.location.href) ? 'Question' : 'Login',
    auth_properties: null,
    context_menu_data: [],
    form_operations: (function () {
      var operations = [];
      operations.operation_complete = function () {
        this.shift();
        this.next_operation();
      };
      operations.next_operation = function () {(this[0] || noop)()};
      return operations;
    })(),
    logged_in: false,
    window_triggers: [],
    shared: {},
    token: null,
    top_menu_data: [],
    top_menu_hotkeys: {},
    windows: [],
    window_pop_delayed: false
  },
  el: '#chi-application',
  methods: {
    activate_previous_window: function (replace) {
      console.debug('activate-previous-window:', this.$options.api.vm);
      var vm = this.$options.api.vm;
      var parent = this.$options.api.vm.$parent;
      if (!replace && !parent)
        return console.warn('activate_previous_window: no $parent');
      this.$options.api.vm = parent = (parent || this.$root);
      this.$options.api.vm_id = this.$options.api.vm._uid;
      window.document.title = parent.title || '';
      parent.background = false;
      parent.default_focus = true;
      var win = $(parent.$el).closest('.k-window');
      this.apply_default_focus(win, parent.active_control);
      // reset styles on the demos ribbon every time it gets redisplayed
      if (win.find('#chi-demos-summary').length)
        for (var key in this.shared)
          if (key.startsWith('chi_chi_demos_')) {
            var props = this.shared[key];
            this.$set(props, 'style', props.orig_props.style);
          }
      //this.$options.api.vm.$refs.map($).forEach(function (element) {
      //  if (KENDO_DATA_KEYS[element.attr('role')])
      //    element.data(KENDO_DATA_KEYS[element.attr('role')]).readonly(false);
      //  else
      //    element.attr('readonly', false);
      //});
      vm.$destroy();
      this.form_operations.operation_complete();
    },
    apply_default_focus: function (container, id) {
      console.debug('apply-default-focus', this, container, id);
      function find_and_filter(container, selector) {
        var result = container.find(selector).filter(function () {
          var target = $(this).not('[readonly], [role="label"], .k-tabstrip');
          return target.length && !target.closest('.k-content[aria-hidden]').length;
        });
        return result.length && result.first();
      }
      var target =
        (id && find_and_filter(container, '#' + id)) ||
        find_and_filter(container, '[data-safe-id]');
      if (target)
        this.$options.api.events['set-field']({
          id: target.attr('id'), role: target.attr('role'), default_focus: true
        });
    },
    apply_grid_selection: function (grid, selection, vm) {
      console.debug('apply-grid-selection', grid, selection, vm);
      // make the selection
      grid.element.data('api-grid-select', true);
      grid.select(selection);
      grid.auto_select_ok = false;
      if (vm)
        // if the grid needs focus, put its cursor on the selection
        setImmediate(function (active) {
          if (active === grid.element.attr('id')) {
            var target = selection.first();
            if (target.prop('tagName') === 'TR')
              target = target.children().first();
            grid.table.focus();
            grid.current(target);
          }
        }, vm.active_control || (vm.$parent && vm.$parent.active_control));
    },
    demask: function (element, value, send_literals) {
      // uses kendo internal property _emptyMask, which contains an underscore
      // anywhere it expects a user character, to demask the value
      var props = this.get_props(element.data('safe-id'));
      var kendo = element.data('kendo-masked-text-box');
      var mask = kendo._emptyMask;
      var prompt = kendo.options.promptChar || '_';
      var new_value = new Array(Math.min(mask.length, value.length));
      if (send_literals === undefined)
        send_literals = props && props.send_literals;
      for (var i = 0, j = 0, l = new_value.length; i < l; ++i) {
        var char = value.charAt(i);
        var mask_char = mask.charAt(i);
        if (send_literals) {
          if (mask_char !== prompt)
            new_value[j++] = mask_char;
          else if (char === prompt)
            new_value[j++] = ' ';
          else
            new_value[j++] = char;
        } else {
          if (mask_char === prompt && char !== prompt)
            new_value[j++] = char;
        }
      }
      return new_value.join('');
    },
    get_buffer_entry: function (id) {
      var buffer = this.$options.buffer;
      var now = Date.now();
      if (buffer[id] && buffer[id]._expires < now)
        delete buffer[id];
      return (buffer[id] = buffer[id] || {
        $callbacks: [], $finally: function () {delete buffer[id]},
        _expires: now + 900000
      });
    },
    get_grid_selection: function (grid) {
      return grid && grid.select().get().map(function (item) {
        item = $(item);
        var is_cell = item.prop('nodeName') === 'TD';
        var row = grid.dataItem(is_cell ? item.parent() : item).id;
        return (is_cell ? [item.index(), row] : row);
      });
    },
    get_props: function (id, vm) {
      vm = vm || this.$options.api.vm;
      var parent = vm.$parent;
      if (vm.closed)
        return this.get_props(id, parent);
      var props = vm.components && vm.components[id];
      if (!props && parent && !parent.closed)
        props = parent.components && parent.components[id];
      return props || vm.$root.get_buffer_entry(id);
    },
    login: function (callback) {
      var self = this;
      console.debug('authenticated; logging in');
      this.$options.socket.connect(this, this.token, function (connected) {
        if (!connected)
          return callback();
        else
          callback(true);
        window.addEventListener('beforeunload', beforeunload);
        var fields = 'input, select, textarea';
        var link = 'a[href="#"][id^="iamclicking-"], div[role="htmlarea"]';
        var masked = 'input[role="maskedtextbox"]';
        var radio = 'input[type="radio"]';
        var submit = 'input[type="submit"]';
        $(document)
          .on('blur.chi', fields, Events.on_blur.bind(self))
          .on('change.chi', Events.on_field_change.bind(self))
          .on('change.chi focus.chi', fields, Events.on_focus.bind(self))
          .on('click.chi', 'button', Events.on_button_click.bind(self))
          .on('click.chi', link, Events.on_link_click.bind(self))
          .on('click.chi', radio, Events.on_radio_click.bind(self))
          .on('click.chi', submit, Events.on_enter_key.bind(self))
          .on('input.chi', masked, Events.on_masked_input.bind(self))
          .on('keydown.chi', Events.on_keydown.bind(self))
          .on('paste.chi', fields, Events.on_paste.bind(self));
        self.context_menu_data = [];
        self.$options.buffer = {};
        self.$options.dependents = {};
        self.$options.recent = new Queue(5000);
        window.addEventListener('message', self.on_message);
      });
    },
    logout: function () {
      window.removeEventListener('message', this.on_message);
      $(document).off('.chi');
      this.auth_component = 'Login';
      this.context_menu_data = [];
      this.logged_in = false;
      this.window_triggers = [];
      this.$options.buffer = {};
      this.$options.dependents = {};
      this.$options.last_context_seq = 0;
      this.$options.last_topmenu_seq = 0;
      if (this.$options.recent)
        this.$options.recent.clear();
      if (this.$options.socket)
        this.$options.socket.disconnect();
      window.removeEventListener('beforeunload', beforeunload);
      window.document.title = variables.title;
    },
    next_field: function on_enter_key(current_field, find_only) {
      console.debug('next-field', this, current_field, find_only);
      current_field = current_field.element || $(current_field);
      var active = current_field.attr('type') !== 'submit' ?
        current_field.attr('id') :
        this.$options.api.vm.active_control;
      var form = current_field.closest('form');
      form.elements = form.elements || Array.from(form.get(0).elements);
      var index =
        form.elements.findIndex(function (el) {return el.id === active});
      if (index > -1)
        for (var i = index + 1, l = form.elements.length; i < index + l; ++i) {
          var el = form.elements[i % l];
          if (
            !el.hasAttribute('readonly') &&
            !el.hasAttribute('disabled') &&
            el.getAttribute('tabindex') !== '-1'
          )
            return find_only ? el : setImmediate(function () {$(el).focus()});
        }
    },
    on_message: function (event) {
      var origin = event.origin;
      if (event.data && event.data.includes('"nuanria_messaging"')) {
        // message came from dragon; ignore
      } else if (SLYCE_URL.startsWith(origin)) {
        // expected but unnecessary; ignore
      } else if (!window.location.href.startsWith(origin)) {
        console.error('Unexpected origin %s', origin);
      } else {
        console.debug('on_message', this, event);
        this.$options.socket.emit('click', {'href': event.data});
      }
    },
    on_window_activate: Form.on_window_activate,
    on_window_close: Form.on_window_close,
    on_window_deactivate: Form.on_window_deactivate,
    on_window_error: Form.on_window_error,
    on_window_open: Form.on_window_open,
    twofa: function (properties) {
      kendo.ui.progress($('#chi-application'), false);
      this.auth_properties = properties;
      this.auth_component = 'TwoFA';
    }
  },
  mounted: function () {
    this.$options.buffer = {};
    this.$options.context_menu = null;
    this.$options.socket = new Socket();
    this.$options.api = new Api(this);
  },
  provide: function () {
    return {
      constants: CONSTANTS,
      // kendo component events
      on_calendar_change: Events.on_calendar_change.bind(this),
      on_context_menu_open: Events.on_context_menu_open.bind(this),
      on_grid_bound: Events.on_grid_bound.bind(this),
      on_grid_navigate: Events.on_grid_navigate.bind(this),
      on_grid_select: Events.on_grid_select.bind(this),
      on_menu_select: Events.on_menu_select.bind(this),
      on_tab_activate: Events.on_tab_activate.bind(this),
      on_tab_contentload: Form.on_tab_contentload.bind(this),
      on_tab_select: Events.on_tab_select.bind(this),
      // grid operations
      td_templates: Grid.td_templates,
      tr_compare: Grid.compare_text,
      tr_compare_date: Grid.compare_date,
      tr_compare_icon: Grid.compare_icon,
      tr_compare_numeric: Grid.compare_numeric,
      tr_compare_time: Grid.compare_time
    };
  }
});

export default window.vm;
